<template>
  <div v-if="llContent || effectIcon.length > 0" class="comment-card">
    <p class="card-title">
      {{ title }}
    </p>
    <div
      v-if="effectIcon.length>0"
      class="icons-group"
    >
      <div
        v-for="(effect_e,effect_k) in effectIcon"
        :key="effect_k"
        class="icon"
      >
        <TextIcon
          :text="effect_e.name"
          :icon="effect_e.icon"
        />
      </div>
    </div>
    <div v-if="llContent" class="card-content">
      <p>{{ llContent }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommentCard",
  props: {
    title: {
      type: String,
      default() {
        return this.$t("ESGoal評析");
      },
    },
    llContent: {
      type: String,
      default: "",
    },
    effectIcon: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/comment-card";
</style>